import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = [];

const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    setTeams: (state, { payload }) => payload,
    updateTeam: (state, { payload }) => {
      const index = state.findIndex((team) => team.uuid === payload.uuid);
      if (index !== -1) {
        state[index] = payload;
      }
    },
  },
});

export const { setTeams, updateTeam } = teamsSlice.actions;

export const teamsReducer = teamsSlice.reducer;

export const teamsSelector = createSelector(
  (state) => state,
  (state) => state.teams,
);
